/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.0
 * @since 1.14.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const TooltipModalStyled = styled.div.attrs({
    className: 'tooltip-modal',
})`
    position: relative;
`;

export const TooltipModalBodyStyled = styled.div.attrs({
    className: 'tooltip-modal__body',
})`
    position: absolute;
    top: calc(100% + 20px);
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;

    display: flex;
    flex-direction: column;

    padding: 16px;
    background: ${colors.labelEditorModuleBg};
    box-shadow: 0 2px 12px 0 ${colors.labelEditorCreateShadow};
`;

// Wrap Tooltip Child
export const TooltipModalChildStyled = styled.div.attrs({
    className: 'tooltip-modal__content',
})`
    width: fit-content;
`;
